import { I18NText } from '../core/api/model/i18NText';

export class ProtocolPdfCategoryWithoutDefectDto {
  public categoryName?: I18NText;
  public categoryShortName?: I18NText;
  public categoryReason?: I18NText | null;
  public displayInspectionReason?: boolean;
}
